/*
* b70-restock-callout.js
* Shows a "More on the way" callout under the PDP buy buttons ONLY when the
* selected variant is confirmed sold out.
*
* v2 (2026-08-28): fixes the flash on variant change. The theme's
* VariantSelects.onVariantChange() sets `disabled` on the add-to-cart button
* while it fetches the new section HTML, then clears it once the variant is
* confirmed in stock. v1 keyed only on `disabled`, so the callout appeared for
* the duration of that fetch on every in-stock variant. v2 requires a real
* sold-out signal: the button's settled text ("Sold out") or the variant data
* embedded in the page. In-flight (disabled + "Add to cart") stays hidden.
*/
(function () {
'use strict';

var CALLOUT_HTML =
'<strong>More on the way!</strong> Tap “Email when available” and ' +
'we’ll let you know the moment your size is back.';

var CSS =
'.b70-restock-callout{display:none;margin:1.2rem 0 .4rem;padding:1.2rem 1.4rem;' +
'background:rgba(0,156,222,.08);border-left:4px solid #009cde;font-size:1.4rem;' +
'line-height:1.5;color:rgb(var(--color-base-text,0,19,27))}' +
'.b70-restock-callout.is-visible{display:block}' +
'.b70-restock-callout strong{font-weight:700}';

function lower(s) {
return String(s || '').trim().toLowerCase();
}

function strings() {
var vs = window.variantStrings || {};
return {
soldOut: lower(vs.soldOut || 'sold out'),
unavailable: lower(vs.unavailable || 'unavailable')
};
}

// Resolve the currently selected variant from the theme's own data, without
// waiting for the section re-render. Returns undefined if it can't be
// determined (callers must treat that as "not sold out").
function selectedVariant(form) {
var picker = document.querySelector('variant-radios, variant-selects');
if (picker && picker.currentVariant) return picker.currentVariant;

var idInput = form && form.querySelector('input[name="id"]');
var id = idInput && Number(idInput.value);
if (!id) return undefined;

var data;
try {
var json = picker && picker.querySelector('[type="application/json"]');
data = json ? JSON.parse(json.textContent) : null;
} catch (e) {
data = null;
}
if (!data) return undefined;
for (var i = 0; i < data.length; i++) {
if (data[i].id === id) return data[i];
}
return undefined;
}

function bind(btn) {
var container = btn.closest('.product-form__buttons') || btn.parentElement;
if (!container || container.dataset.b70RestockBound) return;
container.dataset.b70RestockBound = 'true';

var form = btn.closest('form');
var el = document.createElement('div');
el.className = 'b70-restock-callout';
el.innerHTML = CALLOUT_HTML;
container.insertAdjacentElement('afterend', el);

function update() {
var s = strings();
var txt = lower(btn.textContent);
var disabled = btn.hasAttribute('disabled');
var unavailable = txt.indexOf(s.unavailable) !== -1;

var v = selectedVariant(form);
var soldOut;
if (v) {
// Preferred: the page's variant data for the variant that is selected
// RIGHT NOW. This is updated synchronously by the theme before it
// starts the fetch, so it is never stale mid-transition (the button
// text is: it keeps saying "Sold out" while loading an in-stock size).
soldOut = v.available === false;
} else {
// Fallback when the variant can't be resolved: only trust a settled
// "Sold out" label. In-flight buttons keep their previous text, so a
// plain `disabled` check would flash on in-stock sizes.
soldOut = txt.indexOf(s.soldOut) !== -1;
}

// `disabled` is still required: if a variant was restocked after the
// page rendered, the fetch re-enables the button and this hides again.
var show = disabled && !unavailable && soldOut;
el.classList.toggle('is-visible', show);
}

update();

// Re-evaluate whenever the theme mutates the button (disabled attr, text).
new MutationObserver(update).observe(btn, {
attributes: true,
attributeFilter: ['disabled'],
childList: true,
subtree: true,
characterData: true
});

// Re-evaluate right after a variant change. setTimeout(0) lets the theme's
// own change handler run first (it sets currentVariant + input[name=id]).
document.addEventListener('change', function (e) {
if (e.target && e.target.closest && e.target.closest('variant-radios, variant-selects')) {
setTimeout(update, 0);
}
});
}

function init() {
var buttons = document.querySelectorAll('product-form .product-form__submit');
if (!buttons.length) return;
var style = document.createElement('style');
style.textContent = CSS;
document.head.appendChild(style);
buttons.forEach(bind);
}

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();
